"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("./constants");
var getMonthNames = function (monthNames) {
    return constants_1.MONTH_KEYS.map(function (key) { return monthNames[key]; });
};
exports.default = getMonthNames;
